import React, { FC } from 'react';
import { Redirect } from 'react-router';
import paths from '../paths';

const Wizard: FC<void> = () => {
  return <Redirect to={paths.wizard.services} />;
};

export default Wizard;
